import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronDown, Calendar } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { ARROW_LEFT } from "../../../../assets";

const STATUS_OPTIONS = [
  "Hearing",
  "Mention",
  "Adoption",
  "Ruling",
  "Judgement",
  "Report for service",
  "Pre-trial Conference",
  "Adoption of final written addresses",
  "Addresses",
  "Undefended Appeals",
  "Hearing/Final addresses",
];

const ScheduleHearing = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");

  return (
    <div className="min-h-screen">
      <div className="bg-white border-b border-[#E5E7EB] px-8 py-4">
        <div className="max-w-5xl mx-auto flex items-center gap-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex items-center justify-center w-9 h-9 rounded-full border border-[#E5E7EB] bg-[#F9FAFB] hover:bg-[#F3F4F6]"
          >
            <ChevronLeft className="w-4 h-4 text-[#101828]" />
          </button>
          <div className="flex items-center gap-5 text-sm">
            <span className="text-[#667085]">Cause list</span>
            <span className="text-[#D0D5DD]">
              <img src={ARROW_LEFT} className="w-[19px] h-[19px]" />
            </span>
            <span className="text-[#667085]">Cause list</span>
            <span className="text-[#D0D5DD]">
              {" "}
              <img src={ARROW_LEFT} className="w-[19px] h-[19px]" />
            </span>
            <span className="font-medium text-[#101828]">Schedule Hearing</span>
          </div>
        </div>
      </div>

      <div className="px-8 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl shadow-boxShadow px-10 py-10">
            <h1 className="text-xl font-semibold text-center text-[#101828] mb-10">
              Hearing detail
            </h1>

            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Hearing date</label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="dd/mm/yyy"
                    className="w-full px-4 py-3 rounded-[4px] border border-[#E4E7EC] text-sm text-[#101828] placeholder:text-[#98A2B3] bg-white focus:outline-none focus:border-[#00B074]"
                  />
                  <Calendar className="w-4 h-4 text-[#98A2B3] absolute right-4 top-1/2 -translate-y-1/2" />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Appeal Number</label>
                <div className="relative">
                  <input
                    type="text"
                    defaultValue="EN/006/2024"
                    className="w-full px-4 py-3 rounded-[4px] border border-[#E4E7EC] text-sm text-[#101828] bg-white focus:outline-none focus:border-[#00B074]"
                  />
                  <ChevronDown className="w-4 h-4 text-[#98A2B3] absolute right-4 top-1/2 -translate-y-1/2" />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Case Title</label>
                <div className="relative">
                  <input
                    type="text"
                    defaultValue="Olugbenga Akintola vs Israel Anyemelu"
                    className="w-full px-4 py-3 rounded-[4px] border border-[#E4E7EC] text-sm text-[#101828] bg-white focus:outline-none focus:border-[#00B074]"
                  />
                  <ChevronDown className="w-4 h-4 text-[#98A2B3] absolute right-4 top-1/2 -translate-y-1/2" />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Classification</label>
                <input
                  type="text"
                  defaultValue="Civil"
                  className="w-full px-4 py-3 rounded-[4px] border border-[#E4E7EC] text-sm text-[#101828] bg-white focus:outline-none focus:border-[#00B074]"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Judge</label>
                <input
                  type="text"
                  defaultValue="Hon. Justice. E Agha"
                  className="w-full px-4 py-3 rounded-[4px] border border-[#E4E7EC] text-sm text-[#101828] bg-white focus:outline-none focus:border-[#00B074]"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Court</label>
                <input
                  type="text"
                  defaultValue="Court 8"
                  className="w-full px-4 py-3 rounded-[4px] border border-[#E4E7EC] text-sm text-[#101828] bg-white focus:outline-none focus:border-[#00B074]"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Status</label>
                <Menu as="div" className="relative w-full">
                  <Menu.Button className="w-full flex items-center justify-between px-4 py-3 border border-[#E4E7EC] rounded-lg text-sm bg-[#F9FAFB] text-left">
                    <span
                      className={status ? "text-[#101828]" : "text-[#98A2B3]"}
                    >
                      {status || "Select Status"}
                    </span>
                    <ChevronDown className="w-4 h-4 text-[#98A2B3]" />
                  </Menu.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute z-20 mt-1 w-full rounded-xl bg-white shadow-lg border border-[#E4E7EC] focus:outline-none py-2">
                      <div className="flex flex-col">
                        <span className="px-4 pb-2 text-xs text-[#667085]">
                          Select agenda
                        </span>
                        {STATUS_OPTIONS.map((option) => (
                          <Menu.Item key={option}>
                            {({ active }) => (
                              <button
                                type="button"
                                onClick={() => setStatus(option)}
                                className={`flex items-center justify-between w-full px-4 py-2 text-sm ${
                                  active ? "bg-[#F9FAFB]" : ""
                                }`}
                              >
                                <span className="text-[#101828]">{option}</span>
                                <span className="ml-3 flex items-center justify-center">
                                  <span
                                    className={`w-4 h-4 rounded-full border ${
                                      status === option
                                        ? "border-[#00B074]"
                                        : "border-[#D0D5DD]"
                                    } flex items-center justify-center`}
                                  >
                                    {status === option && (
                                      <span className="w-2 h-2 rounded-full bg-[#00B074]" />
                                    )}
                                  </span>
                                </span>
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Virtual link</label>
                <input
                  type="text"
                  defaultValue="https://docs.google.com/s"
                  className="w-full px-4 py-3 border border-[#E4E7EC] rounded-lg text-sm text-[#2563EB] bg-[#F9FAFB] focus:outline-none focus:border-[#00B074]"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Endorsement</label>
                <textarea
                  rows={3}
                  className="w-full px-4 py-3 border border-[#E4E7EC] rounded-lg text-sm text-[#101828] bg-[#F9FAFB] focus:outline-none focus:border-[#00B074] resize-none"
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-sm text-[#344054]">Adjournment</label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="dd/mm/yyy"
                    className="w-full px-4 py-3 border border-[#E4E7EC] rounded-lg text-sm text-[#101828] placeholder:text-[#98A2B3] bg-[#F9FAFB] focus:outline-none focus:border-[#00B074]"
                  />
                  <Calendar className="w-4 h-4 text-[#98A2B3] absolute right-4 top-1/2 -translate-y-1/2" />
                </div>
              </div>

              <button
                type="button"
                className="mt-4 w-full inline-flex items-center justify-center rounded-lg bg-[#00B074] text-white text-sm font-semibold py-3.5 hover:bg-[#00935F] transition-colors"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleHearing;
